export const styles = (theme) => ({
    wrapDevice: {
        display: "flex",
        alignItems: "center"
    },
})